import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DsIconModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

import { DmsId } from '../../../customer/model/customer-information.model';
import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-dms-id',
  imports: [DsIconModule, DsTooltipDirectiveModule],
  template: `
    <div class="container-fluid ps-0">
      <div class="row flex-nowrap">
        <div class="col-auto">
          @if (ownDmsId()) {
            <ds-icon class="icon" size="md" tone="positive" icon="checkbox_circle" />
          } @else {
            <ds-icon class="icon" size="md" icon="close_circle" />
          }
        </div>

        <div class="col text-col">
          <h4 class="row">{{ i18n('dmsId') }}</h4>
          @if (ownDmsId(); as ownDmsId) {
            <span class="row text-neutral">{{ ownDmsId }}</span>
          } @else {
            <span class="row text-neutral">-</span>
          }
          @if (otherDmsIds().length) {
            <details>
              <summary class="row">{{ i18n('additionalDmsIdsSummary', { count: otherDmsIds().length }) }}</summary>
              @for (otherId of otherDmsIds(); track otherId.dealerId) {
                <span class="row text-neutral">{{
                  i18n('dmsIdForDealer', { dmsId: otherId.dmsId, dealerId: otherId.dealerId })
                }}</span>
              }
            </details>
          }
        </div>
      </div>
    </div>
  `,
  styleUrl: './dms-id.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DmsIdComponent {
  readonly i18n = useI18n();

  readonly ownDpno = input<string>();
  readonly dmsIds = input<DmsId[]>();

  readonly ownDmsId = computed(() => {
    const ownDpno = this.ownDpno();
    return this.dmsIds()?.find(({ dealerId }) => dealerId === ownDpno)?.dmsId;
  });

  readonly otherDmsIds = computed(() => {
    const ownDpno = this.ownDpno();
    return this.dmsIds()?.filter(({ dealerId, dmsId }) => !!dmsId && dealerId !== ownDpno) ?? [];
  });
}
